<template>
    <LayoutHeadingTabs
        :title="translations.title"
        :tabs="tabs"
        isResponsiveCentered
        isOnBackgroundApp
        class="automation-layout"
    >
        <template #actions>
            <CompassMenu placement="bottom-end" customClass="automation-layout__actions-menu">
                <CompassButton
                    :label="translations.createAutomation.labelButton"
                    :loading="isLoadingCreation"
                    dropdown
                />
                <template slot="dropdown">
                    <CompassMenuItem
                        :label="translations.createAutomation.automation"
                        icon="obj-slsy-advanced-automation"
                        @click="handleCreateAutomation"
                    />
                    <CompassMenuItem
                        :label="translations.createAutomation.template"
                        icon="obj-slsy-basic-automation"
                        @click="handleGoToTemplates"
                    />
                </template>
            </CompassMenu>
        </template>
        <template #default>
            <router-view :key="$route.path" />
        </template>
    </LayoutHeadingTabs>
</template>

<script>
import LayoutHeadingTabs from 'vcomponents/common/layout/LayoutHeadingTabs.vue';

import { createAutomation } from 'api/automation/automationService';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    components: {
        LayoutHeadingTabs,
    },
    data() {
        return {
            translations: {
                title: this.$t.__('automation.AutomationLayout.title'),
                createAutomation: {
                    labelButton: this.$t.__('common.actions.create'),
                    automation: this.$t.__('automation.AutomationLayout.create.actions.automation'),
                    template: this.$t.__('automation.AutomationLayout.create.actions.template'),
                },
            },
            tabs: [
                {
                    name: 'automations.listing',
                    label: this.$t.__('automation.AutomationLayout.tabs_listing'),
                },
                {
                    name: 'automations.templates',
                    label: this.$t.__('automation.AutomationLayout.tabs_templates'),
                },
            ],
            isLoadingCreation: false,
        };
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
    },
    methods: {
        handleCreateAutomation() {
            this.isLoadingCreation = true;
            createAutomation()
                .then((response) => {
                    if (response) {
                        this.$router.push({
                            name: 'automations.flow.builder',
                            params: { id: response.data.id },
                        });
                    }
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('automation.AutomationLayout.error.create_automation'),
                    });
                })
                .finally(() => {
                    this.isLoadingCreation = false;
                });
        },
        handleGoToTemplates() {
            if (this.$route.name === 'automations.templates') {
                return;
            }
            this.$router.push({
                name: 'automations.templates',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-layout {
    padding-bottom: 80px;
}
</style>
<style lang="scss">
.compass-menu__dropdown__container.automation-layout__actions-menu {
    z-index: 3;
}
</style>
